<template>
  <div>
    <v-row justify="center">
      <v-dialog
        v-model="dialog"
        persistent
        scrollable
        transition="dialog-top-transition"
        max-width="800px"
      >
        <v-card>
          <v-card-title>
            <i class="icon-Add-user pl-4" style="font-size:55px;"></i>
            <span class="pl-2" style="font-size:40px;">ผู้เกี่ยวข้อง</span>
            <v-spacer></v-spacer>
            <img
              src="img/icons_v2/ico-close@3x.png"
              width="65px"
              height="65px"
              @click="$emit('close')"
            />
          </v-card-title>

          <v-divider></v-divider>

          <div class="scroll-person">
            <div v-for="(items, index) in data" :key="index" class="person">
              <input v-model="selected" type="checkbox" :value="items" />
              <img :src="items.customer_pic" class="img-user" />
              <div>
                <span class="textoverflow">{{ items.name }}</span>
              </div>
            </div>
            <ScrollLoader
              v-show="!loadMore"
              :loader-method="getTeamList"
              :loader-enable="loadMore"
            ></ScrollLoader>
          </div>

          <v-divider></v-divider>
          <div class="footer-save">
            <button type="button" class="button-save" @click="saveSelected()">
              บันทึก
            </button>
          </div>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  props: {
    dialog: Boolean,
    select: Array
  },

  data() {
    return {
      data: [],
      selected: [],
      page: 1,
      total: 0,
      total_pages: 0,
      loadMore: false
    }
  },

  computed: {
    ...mapState({
      user: (state) => state.auth.user
    })
  },

  watch: {
    dialog(nData) {
      if (nData) {
        this.getTeamList()
        this.selected = this.select.length === 0 ? [] : this.select
      }
    }
  },

  methods: {
    getTeamList() {
      const options = {
        url: `${this.$baseAPINew}/mobile/?act=team_list`,
        method: 'POST',
        data: {
          // user_id: this.user.id,
          user_id: 2,
          page: this.page
        }
      }
      this.$axios(options).then((res) => {
        this.total = res.data.total == undefined ? 0 : res.data.total
        this.total_pages = res.data.total_pages == undefined ? 0 : res.data.total_pages
        this.loadMore = this.page >= this.total_pages
        res.data.items && (this.data = [...this.data, ...res.data.items])
        this.page++
      })
    },

    saveSelected() {
      this.$emit('save', this.selected)
    }
  }
}
</script>

<style lang="scss" scoped>
.scroll-person {
  max-height: 800px;
  height: 800px;
  overflow: scroll;
  padding: 10px 20px;
}
.person {
  display: flex;
  align-items: center;
  margin: 30px 15px;
  & input {
    width: 50px;
    height: 50px;
  }
  & span {
    font-size: 32px;
    color: #606060;
  }
}

.img-user {
  border-radius: 50%;
  width: 70px;
  height: 70px;
  margin: 0px 25px;
}

.footer-save {
  display: flex;
  justify-content: center;
  margin: 30px;
}

.button-save {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 500px;
  height: 80px;
  background-color: #a50200;
  color: #ffffff;
  border-radius: 10px;
  font-size: 40px;
}
</style>
